import { CourtOrdered } from "./enums/court-ordered";
import { PlanType } from "./enums/plan-type";

export const isCourtOrdered = (courtOrdered, planType) => {
    //console.log("IsCourtOrdered", courtOrdered, planType);
    if(!courtOrdered)
        return false;
        
    switch(planType){
        case PlanType.Medical:
            return (courtOrdered === CourtOrdered.Med || courtOrdered === CourtOrdered.MedDen || courtOrdered === CourtOrdered.MedDenVis || courtOrdered === CourtOrdered.MedVis);
        case PlanType.Dental:
            return (courtOrdered === CourtOrdered.Den || courtOrdered === CourtOrdered.MedDen || courtOrdered === CourtOrdered.MedDenVis || courtOrdered === CourtOrdered.DenVis);
        case PlanType.Vision:
            return (courtOrdered === CourtOrdered.Vis || courtOrdered === CourtOrdered.MedVis || courtOrdered === CourtOrdered.MedDenVis || courtOrdered === CourtOrdered.DenVis);
        default:
            return false;
        }
}
